import { cn } from '@mntn/ui-components'

// import { Tooltip } from './tooltip'

// Status Badge Configuration
// Note: These badge properties match the ones defined in ui-styleguide
const STATUS_BADGE_SCHEMES = {
  WARNING: { type: 'WARNING', color: '#F59E0B' },
  INFO: { type: 'INFO', color: '#3B82F6' },
  SUCCESS: { type: 'SUCCESS', color: '#10B981' },
  NEUTRAL: { type: 'NEUTRAL', color: '#6B7280' },
  DANGER: { type: 'DANGER', color: '#EF4444' },
}

const STATUS_BADGE_PROPERTIES: Record<
  string,
  {
    label: string
    type: (typeof STATUS_BADGE_SCHEMES)[keyof typeof STATUS_BADGE_SCHEMES]
  }
> = {
  // Campaign Status values
  ACTION_REQ: { label: 'ACTION REQ.', type: STATUS_BADGE_SCHEMES.WARNING },
  ARCHIVED: { label: 'ARCHIVED', type: STATUS_BADGE_SCHEMES.NEUTRAL },
  ENDED: { label: 'ENDED', type: STATUS_BADGE_SCHEMES.NEUTRAL },
  INCOMPLETE: { label: 'INCOMPLETE', type: STATUS_BADGE_SCHEMES.WARNING },
  LEGACY_ARCHIVED: { label: 'ARCHIVED', type: STATUS_BADGE_SCHEMES.DANGER },
  LIVE: { label: 'LIVE', type: STATUS_BADGE_SCHEMES.SUCCESS },
  PAUSED: { label: 'PAUSED', type: STATUS_BADGE_SCHEMES.NEUTRAL },
  READY: { label: 'READY', type: STATUS_BADGE_SCHEMES.INFO },
  SCHEDULED: { label: 'SCHEDULED', type: STATUS_BADGE_SCHEMES.SUCCESS },
}

interface StatusBadgeProps {
  status?: string | null
  details?: string | null
  variant?: 'dark'
}

// biome-ignore lint/plugin: RETIRED, do not copy. Convert to a named function export when touching this.
export const StatusBadge: React.FC<StatusBadgeProps> = ({ status, variant }) => {
  if (!status) {
    return <span className="text-sm text-secondary">-</span>
  }

  const statusConfig = STATUS_BADGE_PROPERTIES[status]
  if (!statusConfig) {
    return <span className="text-sm text-secondary">-</span>
  }

  const StatusContent = (
    <div className="flex items-center gap-2">
      {/* 8x8 circle icon */}
      <div className="w-2 h-2 rounded-full flex-shrink-0" style={{ backgroundColor: statusConfig.type.color }} />
      {/* Status text */}
      <span className={cn('text-xs font-regular', variant === 'dark' ? 'text-primary-inverse' : 'text-primary')}>
        {statusConfig.label}
      </span>
    </div>
  )

  // Only wrap with tooltip if details exist
  // if (!details) {
  //   return StatusContent
  // }

  // return (
  //   <Tooltip
  //     trigger={StatusContent}
  //     content={details}
  //     variant={variant === 'dark' ? 'dark' : 'light'}
  //     side="top"
  //     delayDuration={300}
  //   />
  // )

  return StatusContent
}
